import Vue from "vue";
import VueRouter from "vue-router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import store from './store';
import router from "./router.js";
import "./assets/css/common.css";
import Comjs from "./assets/js/common.js";
import "font-awesome/css/font-awesome.min.css";
import './plugins/component';
// import axios from "axios";
// import Cookies from "js-cookie";
import * as filters from "./filters"; // global filters
import Purecss from "purecss";
// import G2 from "@antv/g2";
import directive from "./assets/js/directive";
import VueCropper from "vue-cropper";
import "./qw.js"; // 登录页配置
Vue.use(VueCropper);
import { httpAuthAxios, exportAuthAxios } from "./api/request";
import moment from "moment";
moment.locale("zh-cn");
Vue.prototype.$moment = moment;

//加载路由中间件
Vue.use(VueRouter);

Vue.use(Purecss);

Vue.use(ElementUI);
Vue.prototype.$common = Comjs;

// register global utility filters.
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.prototype.$httpAuth = httpAuthAxios;
Vue.prototype.$exportAuth = exportAuthAxios;
// 全局注册
Object.keys(directive).forEach((fncName) => {
  Vue.directive(fncName, directive[fncName]);
});

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
  router,
  store
}).$mount("#app");
